module.exports = __webpack_public_path__ + "media/application/images/svgs/tablet-0f1dc3279943ca3ef257fcf20e61ee9c.svg";